import { useCallback, useEffect, useState } from "react";
import { listEkycQueue } from "./ekycReviewsApi.js";

export const EKYC_QUEUE_PAGE_SIZE = 25;

/**
 * P149: the e-KYC work queue.
 *
 * `filters` must be a stable object reference - build it with useMemo in the
 * caller. Previous data stays visible while a refetch is in flight so a filter
 * change shows an inline indicator instead of blanking the whole screen.
 *
 * `reloadToken` lets the caller force a refetch after an action (starting a
 * review, recording a decision, creating a profile) so the row's state and the
 * KPI counts both come from the server rather than being patched locally.
 */
export function useEkycQueue(filters, reloadToken = 0) {
  const [state, setState] = useState({ status: "loading", data: null, error: null });
  const [ownToken, setOwnToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState((previous) => ({ status: "loading", data: previous.data, error: null }));

    listEkycQueue(filters)
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState((previous) => ({ status: "error", data: previous.data, error }));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [filters, reloadToken, ownToken]);

  const refetch = useCallback(() => setOwnToken((token) => token + 1), []);

  return { ...state, refetch };
}
